module.exports = __webpack_public_path__ + "img/works_feilang_go_3.95dbd5b1.png";